import { useSyncExternalStore } from 'react';

import {
	getInitialPublishedSuggestionsSnapshot,
	getPublishedSuggestionsSnapshot,
	subscribeToPublishedSuggestions,
	type PublishedSuggestionsState,
} from './publishedSuggestionsStore.ts';

export const usePublishedSuggestionsState = (): PublishedSuggestionsState =>
	useSyncExternalStore(
		subscribeToPublishedSuggestions,
		getPublishedSuggestionsSnapshot,
		getInitialPublishedSuggestionsSnapshot,
	);
